import { ANALYTICS_UPDATE_DATE_PROPS } from "AnalyticscommonActions";

export function AnalyticscommonDatePropsReducer(
  state = { from: null, to: null, enteredTo: null },
  action
) {
  switch (action.type) {
    case ANALYTICS_UPDATE_DATE_PROPS:
      return action.payload;
    default:
      return state;
  }
}
